import { sdk } from '@/lib/medusa';

export async function getExhibitions({ limit = 50 } = {}) {
  try {
    const { exhibitions } = await sdk.client.fetch('/store/exhibitions', {
      method: 'GET',
      query: { limit },
      next: { tags: ['exhibitions'], revalidate: 300 },
    });
    return exhibitions || [];
  } catch (e) {
    console.error('[exhibitions] fetch failed:', e);
    return [];
  }
}
